import { InjectionToken } from '@angular/core';

export const OCL_LOGBOOK_MODAL_TOKEN = new InjectionToken<any>('OclLogbookModalComponent');
